import { useState, useEffect } from 'react';
import { modernTravelTabs } from '../../../../data/landingPage/landingPageData';
import ModernTravelHeader from './sections/ModernTravelHeader';
import ModernTravelCarousel from './sections/ModernTravelCarousel';
import ModernTravelControls from './sections/ModernTravelControls';

const ModernTravelSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const tabs = modernTravelTabs;

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % tabs.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex, tabs.length]);

  const handleNext = () => setActiveIndex((prev) => (prev + 1) % tabs.length);
  const handlePrev = () => setActiveIndex((prev) => (prev - 1 + tabs.length) % tabs.length);

  return (
    <section className="py-24 bg-white relative overflow-hidden">
      <div className="w-full space-y-10">
        {/* Header */}
        <ModernTravelHeader />

        {/* Full-Width Peeking Carousel */}
        <ModernTravelCarousel
          tabs={tabs}
          activeIndex={activeIndex}
          onSelectTab={setActiveIndex}
        />

        {/* Carousel Controls */}
        <ModernTravelControls
          totalCount={tabs.length}
          activeIndex={activeIndex}
          onPrev={handlePrev}
          onNext={handleNext}
          onSelectIndex={setActiveIndex}
        />
      </div>
    </section>
  );
};

export default ModernTravelSection;
